import React, { Component } from "react";
import { AvForm, AvField, AvGroup } from "availity-reactstrap-validation";
import {
	Row,
  CustomInput,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label
} from "reactstrap";
import IntlMessages from "../../../helpers/IntlMessages";
import { Colxx} from "../../../components/common/CustomBootstrap";
import Select from "react-select";
import CustomSelectInput from "../../../components/common/CustomSelectInput";
import {REST_API_END_POINT,dataEncryptKey,JQUERY_MODULE} from "../../../constants/defaultValues";
import axios from 'axios';
import SimpleCrypto from "simple-crypto-js";

var dataCrypto = new SimpleCrypto(dataEncryptKey);




const selectStatus = [
    { label: "Inactive", value: "0", key: 0 },
    { label: "Active", value: "1", key: 1 }
];
   
class EditRoomModal extends Component{
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
	
	this.state = {
		selectStatus:{ label: "Active", value: "1", key: 1 },
		readOnly: true,
		room:null,
       	room_no:null,
        room_structures: []		
		};
	
  }
	componentDidMount() {
		var facility_id = localStorage.getItem('facility_id');
		facility_id =  dataCrypto.decrypt(facility_id);
			
		var formData = new FormData();
		formData.append('facility_id',facility_id);
		
		axios.post(REST_API_END_POINT+'inventory/get-available-rooms',formData).then((res)=>{
			var data = res.data;
			var room_nos = data.room_nos;
			
			this.setState({
				room_structures:room_nos
			});
		}).catch(e =>{
			console.log("Addition failed , Error ", e);
			document.getElementById("add-room").disabled=false;
		});
	
	}
	
	componentDidUpdate(prevProps, prevState, snapshot){	   
        if(this.props.modalOpen){
			let room; 		  
            if (prevProps.room_id !== this.props.room_id && this.props.room_id!=0) {
				var formData = new FormData();
				formData.append('room_id',this.props.room_id);
	
				axios.post(REST_API_END_POINT+'inventory/get-room-by-id',formData).then((res)=>{
					var data = res.data;
					var status=null;
					room=data.room;
					
					selectStatus.forEach((element,index) => { 
						if(element.value==room.status){
							status=element;
						}
					});
					var room_nos = data.room_nos;
					room_nos.push({'value':parseInt(room.position),'available':true});
					room_nos.sort((a, b) => {
							if (a.value < b.value) return -1
							return a.value > b.value ? 1 : 0
						});
					this.setState({ 
						room,
						room_no:room.position,
						room_structures:room_nos,
						status
					});
					
				}).catch(e =>{
					console.log("Addition failed , Error ", e);
				});	
			}
		}
	}
  
  handleSubmit(event, errors, values) {		
		if (errors.length === 0) {			
			document.getElementById("update-room").disabled=true;
			
			var user_id = localStorage.getItem('user_id');
			var facility_id = localStorage.getItem('facility_id');
			facility_id =  dataCrypto.decrypt(facility_id);
			
			var formData = new FormData(document.getElementById("roomForm"));
			formData.append('room_id',this.props.room_id);
			formData.append('facility_id',facility_id);
			formData.append('user_id',user_id);

			axios.post(REST_API_END_POINT+'inventory/edit-room',formData).then((res)=>{
				var data = res.data;
				
				var room=this.state.room;
				room.name=values.room;
				this.setState({ room });
				
				var api_message=document.getElementById("api_message");
				api_message.innerHTML="<div class=\"rounded alert alert-success alert-dismissible fade show\" role=\"alert\"><button type=\"button\" class=\"close\" aria-label=\"Close\"><span aria-hidden=\"true\">×</span></button><span>"+data.msg+"</span></div>";
				
				window.setTimeout(function() {
					JQUERY_MODULE.$(".alert").fadeTo(500, 0).slideUp(500, function(){
						JQUERY_MODULE.$(this).remove();
					});
				}, 5000);
				
				JQUERY_MODULE.$('.alert .close').on("click", function(e){
					JQUERY_MODULE.$(this).parent().fadeTo(500, 0).slideUp(500, function(){
						JQUERY_MODULE.$(this).remove();
					});
				});
				
				document.getElementById("update-room").disabled=false;
				this.props.toggleModal();
				this.props.dataListRender();

			}).catch(e =>{
				console.log("Addition failed , Error ", e);
				document.getElementById("update-room").disabled=false;
			});

		}
	}
 
 
  handleClick = (room_no) => {
        this.setState({
			room_no
        });
      };
 


  render() {

  if(this.state.room!=null){
	var room=this.state.room;
}else{
	var room;
}
	  
	  return (
	  
		<Modal
		  isOpen={this.props.modalOpen}
		  toggle={this.props.toggleModal}
		  wrapClassName="modal-right"
		  size="md"
		>
		  <ModalHeader toggle={this.props.toggleModal}>
			Edit Room
		  </ModalHeader>
		  <AvForm
		        id="roomForm"
				className="av-tooltip tooltip-right-bottom"
				onSubmit={this.handleSubmit}
			  >
		  <ModalBody>
				<Row>
					<Colxx lg="12">
						<AvGroup className="error-t-negative">
						  <Label>Name<span className="text-danger">*</span></Label>
						  <AvField
							id="name"
							name="name"
							type="text"
							autoComplete="off"
							value={ room?((room.name!=null)?room.name:''):'' }
							validate={{
							  required: {
								value: true,
								errorMessage: "This field is required."
							  },
							  pattern: {
								value: "^[a-zA-Z0-9 ,.'-]+$",
								errorMessage: "Invalid name"
							  },
							  minLength: {
								value: 2,
								errorMessage:
								  "The name must be between 2 and 100 characters"
							  },
							  maxLength: {
								value: 100,
								errorMessage:
								  "The name must be between 2 and 100 characters"
							  }
							}}
						  />
						</AvGroup>
					</Colxx>					
				</Row>
				<Row>
					<Colxx lg="12">
						<AvGroup className="error-t-negative">
						  <Label>Room No.<span className="text-danger">*</span></Label>
						  <AvField
							id="room-no"
							name="position"
							type="number"
							value={this.state.room_no}
                            readOnly={true}
							validate={{
							  required: {
								value: true,
								errorMessage: "Please enter numeric value"
							  }							  
							}}
						  />
						</AvGroup>
					</Colxx>					
				</Row>
				<hr/>
				<h5>Choose any one of Available Room</h5>
				
				{this.state.room_structures.map((row,index)=>{
					return (<span key={index} className={"w-40px p-2 m-1 border d-inline-block text-center cursor-pointer "+(this.state.room_no==row.value ? "room-active":"")} onClick={()=>{this.handleClick(row.value)}} >
							{row.value}
							</span>)
				})}		
				<div className="mt-3">
					<Label >Status</Label>
						 <Select
							components={{ Input: CustomSelectInput }}
							className="react-select"
							classNamePrefix="react-select"						
							name="status"
							id="status"
							value={this.state.status}						
							options={selectStatus}
							onChange={status => { this.setState({ status }) }}
						/>	
				</div>
				
		  </ModalBody>
		  <ModalFooter>
			<Button color="primary" id="update-room" >
			  <IntlMessages id="customer.save" />
			</Button>
			<Button color="secondary" outline onClick={this.props.toggleModal}>
			  <IntlMessages id="customer.cancel" />
			</Button>{" "}
		  </ModalFooter>
		   </AvForm>
	  </Modal>
	  );
  }
};

export default EditRoomModal;
